/* eslint-disable prettier/prettier */

import { apiService } from './api.service';

export interface DownloadedAzureFile {
	file: string;
	filename: string;
	mimetype: string;
}

class AzureFileService {
	/**
	 * Download a file from Azure Blob Storage
	 *
	 * Backend:
	 * GET /azurefiles/:fileId/download
	 *
	 * The backend returns a base64 data URL:
	 * {
	 *   file: "data:application/pdf;base64,...",
	 *   filename: "assignment.pdf",
	 *   mimetype: "application/pdf"
	 * }
	 */
	async downloadFile(
		fileId: string
	): Promise<DownloadedAzureFile> {
		try {
			if (!fileId) {
				throw new Error('File ID is required.');
			}

			console.log(
				'📥 Download file request:',
				fileId
			);

			const response =
				await apiService.get<DownloadedAzureFile>(
					`/file/${encodeURIComponent(fileId)}/download`
				);

			console.log(
				'✅ Download file response:',
				response
			);

			if (!response?.success) {
				throw new Error(
					response?.message ||
						'Failed to download file.'
				);
			}

			if (!response.data) {
				throw new Error(
					'Download response did not contain file data.'
				);
			}

			return response.data;
		} catch (error: any) {
			console.error(
				'❌ Azure file download failed:',
				error
			);

			throw new Error(
				error?.response?.data?.message ||
					error?.message ||
					'Failed to download file.'
			);
		}
	}
}

export const azureFileService = new AzureFileService();